import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { FormControlChildAbstract } from '~/component/form/abstracts/control-child.abstract';
import { FormCheckboxGroupFormControlValueInterface } from '~/component/form/checkbox/group/interfaces/form-control-value.interface';
import { IconStyleEnum } from '~/component/icon/enums/icon-style.enum';
import { generateUid } from '~/core/helpers/uid/uid.helper';

import { CheckboxAlignEnum } from './enums/checkbox-align.enum';
import { IconTypeEnum } from '~/component/icon/enums/icon-type.enum';

@Component({
  selector: 'app-form-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FormCheckboxComponent,
      multi: true,
    },
  ],
})
export class FormCheckboxComponent extends FormControlChildAbstract<
  boolean | FormCheckboxGroupFormControlValueInterface
> {
  @Input() public align?: CheckboxAlignEnum;
  @Input() public ariaLabel?: string;
  @Input() public description = '';
  @Input() public label?: string;
  @Input() public name?: string;

  private readonly uid = generateUid();

  public get checked(): boolean {
    if (typeof this.value === 'object') {
      return this.value?.checked || false;
    } else if (typeof this.value === 'boolean' || this.value === undefined) {
      return !!this.value;
    } else {
      throw new Error('Checkbox component - Invalid value.');
    }
  }

  public get iconName(): IconTypeEnum {
    return this.checked ? IconTypeEnum.Checkbox : IconTypeEnum.CheckBoxBlank;
  }

  public get iconStyle(): IconStyleEnum {
    return this.checked ? IconStyleEnum.FILL : IconStyleEnum.LINE;
  }

  public get inputState(): string {
    if (this.hasError) {
      return 'form-checkbox--error';
    }

    if (this.disabled) {
      return 'form-checkbox--disabled';
    }

    return '';
  }

  public get inputUid(): string {
    return `form-checkbox-${this.uid}`;
  }

  public onChange(): void {
    if (typeof this.value === 'object') {
      this.value =
        this.value === null
          ? true
          : // Set the value object to keep validation reactivity.
            { ...this.value, checked: !this.value.checked };
    } else if (typeof this.value === 'boolean' || this.value === undefined) {
      this.value = !this.value;
    } else {
      throw new Error('Checkbox component - Invalid value.');
    }
  }
}
